import { Injectable } from '@angular/core';
import { AllowedSectionTypes } from './AllowedSectionTypes';
import { IDocMergeAllowedSectionsService } from './IDocMergeAllowedSectionsService';

@Injectable({
  providedIn: 'root',
})
export class SalesforceDocMergeAllowedSectionsService implements IDocMergeAllowedSectionsService {
  getAllowedSections(): AllowedSectionTypes {
    return new AllowedSectionTypes(false, true, true, true);
  }
}
